<template>
    <el-dialog
        :closeOnClickModal="false"
        :title="title"
        :visible="true"
        :before-close="beforeClose"
        :class="'performanceBatchReceiptUpload'"
        :width="width"
    >
        <el-form
            ref="receiptUploadForm"
            :model="receiptUploadForm"
            :rules="receiptUploadFormRules"
            label-width="85px"
        >
            <el-form-item label="上传分类：" prop="batchFlag">
                <el-select v-model="receiptUploadForm.batchFlag" clearable style="width: 100%">
                    <el-option
                        v-for="item in batchFlagList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="附件：" prop="fileUrl">
                <performance-common-upload
                    ref="performanceCommonUpload"
                    :accept="'.jpg,.jpeg,.png,.tif,.bmp'"
                    :multiple="true"
                    :compressImage="true"
                    :maxSize="2"
                    @remove="handleRemove"
                    @beforeUpload="beforeUpload"
                    @callback="uploadResponse"
                ></performance-common-upload>
            </el-form-item>
        </el-form>
        <div class="tips">
            <p>
                <span>注意事项1：</span>
                <span class="strongText">如果一个单号需要上传多张图片，图片命名请以单号-1，单号-2等结尾。</span>
            </p>
            <p>
                <span>注意事项2：</span>
                <span class="strongText">上传单个文件不能超过8M。</span>
            </p>
        </div>
        <template #footer>
            <div>
                <el-button type="primary" :loading="uploadLoading" @click="handleUpload">上传</el-button>
            </div>
        </template>
    </el-dialog>
</template>
<script>
import PerformanceCommonUpload from './PerformanceCommonUpload.vue';
import { mapState } from 'vuex';
import { uploadReceipt } from '@/modules/transport/otp/api/performanceReceiptSign.js';
export default {
    name: 'performanceBatchReceiptUpload',
    components: { PerformanceCommonUpload },
    props: {
        title: {
            type: String,
            default: '批量上传回单'
        },
        width: {
            type: String,
            default: '600px'
        },
        selected: {
            type: Array,
            default () {
                return [];
            }
        }
    },
    data () {
        return {
            uploadLoading: false, // 上传按钮加载动画
            receiptUploadForm: { // 表单数据
                batchFlag: '',
                fileUrl: ''
            },
            receiptUploadFormRules: { // 表单校验规则
                batchFlag: [{ required: true, message: '请选择上传分类', trigger: ['change'] }],
                fileUrl: [{ required: true, message: '请选择附件', trigger: ['change'] }]
            },
            batchFlagList: [ // 上传分类列表
                { label: '按选择数据维度', value: 'select' },
                { label: '按发车单号维度', value: 'dispatchNo' },
                { label: '按客户订单号维度', value: 'custOrderNo' },
                { label: '按合同号维度', value: 'contractNo' },
                { label: '按集配单号维度', value: 'collectNo' }
            ],
            uploadData: [] // 上传成功后数据
        };
    },
    computed: {
        ...mapState({ user: state => state.user })
    },
    methods: {
        /**
         * @description 上传前校验文件格式
         * @param {Object} file 文件对象
         */
        beforeUpload (file) {
            this.uploadLoading = true;
        },

        /**
         * @description 文件上传成功回调
         * @param {Object} uploadData 上传成功回调的数据
         */
        uploadResponse (uploadData) {
            this.uploadLoading = false;
            this.uploadData = uploadData;
            this.receiptUploadForm.fileUrl = this.uploadData[0].fileUrl;
            this.$refs.receiptUploadForm.clearValidate('fileUrl');
        },

        /**
         * @description 处理批量上传参数
         */
        dealWithBatchUploadParams () {
            const reqParams = {
                createUserName: this.user.userName, // 上传人
                createUserCode: this.user.userCode, // 上传人编码
                signFileUpload: 'N', // 是否回传 (Y：已回传 N：未回传)
                receiptSource: '10', // 上传方式 (0：APP端 10：PC端 20：微信)
                fileUrls: this.uploadData.map(v => (v.fileUrl)), // 批量上传的文件url集合
                fileData: this.uploadData.map(v =>
                    ({
                        fileName: v.fileName,
                        fileUrl: v.fileUrl
                    })
                ) // 批量上传的文件url、name集合
            };
            if (this.receiptUploadForm.batchFlag === 'select') {
                // 选中的列表数据运输单号集合。（按发车单号、客户订单号、合同号、集配单号等维度时必传）
                reqParams.taskNoList = this.selected.map(v => (v.taskNo));
            } else {
                // 按什么数据维度来批量新增 (发车单号：dispatchNo，客户订单号：custOrderNo，合同号：contractNo，集配单号：collectNo)
                reqParams.batchFlag = this.receiptUploadForm.batchFlag;
            }
            return reqParams;
        },

        /**
         * @description 上传
         */
        handleUpload () {
            Promise.resolve(this.$refs.receiptUploadForm.validate()).then(() => {
                // 按选择数据维度上传，必须选中一条数据
                if (this.receiptUploadForm.batchFlag === 'select' && this.selected.length === 0) {
                    return this.$message.warning('按选择数据维度，没有选择数据，不能上传附件！');
                }
                const reqParams = this.dealWithBatchUploadParams();
                this.uploadLoading = true;
                uploadReceipt(reqParams).then(res => {
                    if (Array.isArray(res.data) && res.data.length > 0) {
                        let message = '';
                        res.data.forEach(item => {
                            message += `<div>${item.message}</div>`;
                        });
                        const duration = 5000 + res.data.length * 1500;
                        this.$message({
                            type: 'error',
                            duration,
                            showClose: true,
                            dangerouslyUseHTMLString: true,
                            message
                        });
                    } else {
                        this.$message.success('批量上传成功');
                        this.$emit('success', 'batchReceiptUploadVisible');
                    }
                }).catch(() => { this.$message.error('上传失败'); }).finally(() => { this.uploadLoading = false; });
            }).catch(() => { });
        },

        /**
         * @description 移除文件
         * @param {Array} uploadData 剩余未移除的文件列表
         */
        handleRemove (uploadData) {
            this.uploadData = uploadData;
            this.receiptUploadForm.fileUrl = this.uploadData.length > 0 ? this.uploadData[0].fileUrl : '';
        },

        beforeClose () {
            this.$emit('update:batchReceiptUploadVisible', false);
        }
    }
};
</script>
<style lang="less">
.performanceBatchReceiptUpload {
    .tips {
        padding-top: 2px;
        .strongText {
            color: #f00;
        }
    }
    .el-upload-list__item {
        transition: none;
    }
}
</style>
